import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.pooling.algorithm`. */
export const editPooling = async (algorithm: string): Promise<any> =>
  writeSettingsFields({ pooling: { algorithm } });
